"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  NONE: 'none',
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger'
};
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb25zdGFudHMvc3JjL0ludGVudC5qcyJdLCJuYW1lcyI6WyJOT05FIiwiU1VDQ0VTUyIsIldBUk5JTkciLCJEQU5HRVIiXSwibWFwcGluZ3MiOiI7Ozs7OztlQUFlO0FBQ2JBLEVBQUFBLElBQUksRUFBRSxNQURPO0FBRWJDLEVBQUFBLE9BQU8sRUFBRSxTQUZJO0FBR2JDLEVBQUFBLE9BQU8sRUFBRSxTQUhJO0FBSWJDLEVBQUFBLE1BQU0sRUFBRTtBQUpLLEMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCB7XG4gIE5PTkU6ICdub25lJyxcbiAgU1VDQ0VTUzogJ3N1Y2Nlc3MnLFxuICBXQVJOSU5HOiAnd2FybmluZycsXG4gIERBTkdFUjogJ2Rhbmdlcidcbn1cbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./~/evergreen-ui/commonjs/constants/src/Intent.js
// module id = 151
// module chunks = 0